// extracted by mini-css-extract-plugin
export var measureBox = "_bd-0";